import React, { useState, useRef } from "react";
import { Button } from "primereact/button";
import { Responsive, WidthProvider } from "react-grid-layout";
import { Card, Col, Row } from 'react-bootstrap';
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { Avatar } from 'primereact/avatar';
import { InputTextarea } from "primereact/inputtextarea";
import { Dialog } from "primereact/dialog";
import { getSocket } from '../context/socket'; // adjust path as needed
import { useAuth } from '../context/AuthContext';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Link } from "react-router-dom";
const ResponsiveGridLayout = WidthProvider(Responsive);


const ImageSection = ({ section, cardId }) => {
    const socket = getSocket();
    const layout = section.images.map((image, i) => ({
        i: image.image_id.toString(),
        x: image.x,
        y: image.y,
        w: image.w,
        h: image.h
    }));

    const op = useRef(null);

    const handleLayoutChange = (newLayout) => {
        const updatedPositions = newLayout.map(item => ({
            image_id: parseInt(item.i),
            x: item.x,
            y: item.y,
            w: item.w,
            h: item.h
        }));

        socket.emit("bulk_update_image_positions", {
            card_section_id: section.section_id,
            positions: updatedPositions,
            card_id: cardId
        });
    };

    const { userId } = useAuth();
    const [showCommentId, setShowCommentId] = useState(null);
    const [commentText, setCommentText] = useState('');

    const handleAddComment = (img) => {
        socket.emit("add_card_comment", {
            card_id: cardId,
            card_section_id: section.section_id,
            reference_id: img.image_id,
            comment_type: "image",
            comment_text: commentText,
            user_id: userId
        });

        setCommentText('');
    };

    const handleResolveComment = (comment_id) => {
        socket.emit("resolve_card_comment", {
            card_id: cardId,
            comment_id,
            user_id: userId
        });

    };


    const [showEditDialog, setShowEditDialog] = useState(false);
    const [imageToEdit, setImageToEdit] = useState(null);
    const [newFileData, setNewFileData] = useState(null); // base64 file + filename

    const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
    const [selectedImageToDelete, setSelectedImageToDelete] = useState(null);


    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setNewFileData({
                file: reader.result.split(",")[1], // base64 without prefix
                filename: file.name
            });
        };
        reader.readAsDataURL(file);
    };

    const handleDeleteImage = (img) => {
        socket.emit("delete-card-image", {
            image_id: img.image_id,
            card_id: cardId,
            user_id: userId
        });
    };

    const handleEditImage = () => {
        if (!newFileData || !imageToEdit) return;

        socket.emit("edit-card-image", {
            image_id: imageToEdit.image_id,
            newFile: newFileData,
            card_id: cardId,
            user_id: userId
        });

        setShowEditDialog(false);
        setNewFileData(null);
        setImageToEdit(null);
    };



    /*------------Image Cropper----------------*/

    const [showCrop, setShowCrop] = useState(false);
    const [cropData, setCropData] = useState(null);
    const [crop, setCrop] = useState({ aspect: 0 }); // aspect 0 = free-form
    const [completedCrop, setCompletedCrop] = useState(null);
    const [imageRef, setImageRef] = useState(null);
    const [cropDialogSize, setCropDialogSize] = useState({ width: 600, height: 400 });
    const [currentImage, setCurrentImage] = useState(null);



    return (
        <>
            <div className="d-flex justify-content-between align-items-start">
                <h6><i className="pi pi-camera me-2 text-warning"></i> <b>{section.section_name}</b></h6>
            </div>

            <Row>
                <Col lg={12} md={12} sm={12} className="p-0">
                    <ResponsiveGridLayout
                        className="layout taskdataLink"
                        layouts={{ lg: layout }}
                        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                        cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                        rowHeight={100}
                        isDraggable={true}
                        draggableCancel=".no-drag"
                        onLayoutChange={handleLayoutChange} // 👈 Trigger position sync
                    >
                        {section.images.map((img) => {
                            const overlayRef = React.createRef();

                            return (
                                <div
                                    className={`d-flex align-items-center gap-3 justify-content-between catdHover py-2 ${showCommentId === img.image_id ? 'example-1' : ''}`}
                                    key={img.image_id.toString()}
                                    style={{
                                        borderRadius: "8px",
                                        position: "relative",
                                    }}
                                >
                                    <img
                                        src={img.croppedVersion?.cdn_url || img.cdn_url}
                                        alt={img.filename}
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                            overflow: "hidden",
                                            position: 'relative',
                                            zIndex: '1'
                                        }}
                                    />
                                    <div className="imGbuttonList no-drag" style={{ zIndex: '1' }}>
                                        <div className="position-relative">
                                            <Button
                                                icon="pi pi-comments"
                                                tooltip="Comment"
                                                className="border-0 p-1"
                                                text
                                                onClick={() =>
                                                    setShowCommentId(prev => prev === img.image_id ? null : img.image_id)
                                                }
                                            />
                                            {img.comments?.length > 0 && (
                                                <span
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-10px',
                                                        right: '-10px',
                                                        background: 'rgb(245 164 1)',
                                                        color: '#fff',
                                                        borderRadius: '50%',
                                                        width: '20px',
                                                        height: '20px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '9px',
                                                    }}
                                                >
                                                    {img.comments.length}
                                                </span>
                                            )}
                                        </div>
                                        <Button
                                            icon="pi pi-ellipsis-v"
                                            tooltip="More"
                                            className="border-0 p-1"
                                            text
                                            onClick={(e) => {
                                                setCurrentImage(img); // store the selected image
                                                overlayRef.current?.toggle(e);
                                            }}
                                        />
                                        <OverlayPanel ref={overlayRef}>
                                            <ul className="overlay-extraList pt-2 buttonList">
                                                <li onClick={() => {
                                                    setCropData({ url: img.cdn_url, imageId: img.image_id });
                                                    setShowCrop(true);
                                                }}>
                                                    <i className="pi pi-expand pe-2"></i>Crop
                                                </li>
                                                <li onClick={() => window.open(img.cdn_url, '_blank')}>
                                                    <i className="pi pi-image pe-2"></i>Full Image
                                                </li>
                                                <li onClick={() => {
                                                    setImageToEdit(img);
                                                    setShowEditDialog(true);
                                                }}>
                                                    <i className="pi pi-pencil pe-2"></i>Edit
                                                </li>
                                                <li onClick={() => {
                                                    setSelectedImageToDelete(img);
                                                    setDeleteDialogVisible(true);
                                                }}>
                                                    <i className="pi pi-trash pe-2"></i>Delete
                                                </li>
                                            </ul>
                                        </OverlayPanel>
                                    </div>
                                </div>
                            );
                        })}



                        {/* <Button
                                        icon="pi pi-expand"
                                        tooltip="Crop"
                                        className="border-0 p-1"
                                        text
                                        onClick={() => {
                                            setCropData({ url: img.cdn_url, imageId: img.image_id });
                                            setShowCrop(true);
                                        }}
                                    />
                                    <Button
                                        icon="pi pi-image"
                                        tooltip="View Full Image"
                                        className="border-0 p-1"
                                        text
                                        onClick={() => {
                                            window.open(img.cdn_url, '_blank');
                                        }}
                                    />
                                    <Button
                                        icon="pi pi-pencil"
                                        tooltip="Edit"
                                        className="border-0 p-1"
                                        text
                                        onClick={() => {
                                            setImageToEdit(img);
                                            setShowEditDialog(true);
                                        }}
                                    />

                                    <Button
                                        icon="pi pi-trash"
                                        tooltip="Delete"
                                        className="border-0 p-1"
                                        text
                                        onClick={() => {
                                            setSelectedImageToDelete(img);
                                            setDeleteDialogVisible(true);
                                        }}
                                    /> */}

                        {/* </div>
                </div>
                        ))} */}
                    </ResponsiveGridLayout>
                </Col >
                <div className="p-0">
                    {/* Comment popup */}
                    {showCommentId && (
                        <div className="img-comment mt-3 ">
                            <Button
                                icon="pi pi-times"
                                className="p-button-text cmtclose"
                                style={{
                                    position: 'absolute',
                                    top: '-9px',
                                    right: '-5px',
                                    padding: '0px',
                                    background: '#ff0000',
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '50% !important',
                                    left: 'auto',
                                    color: '#fff',
                                }}
                                onClick={() => setShowCommentId(null)}
                            />

                            {section.images.find(img => img.image_id === showCommentId)?.comments?.map(comment => (
                                <div
                                    key={comment.comment_id}
                                    className='d-flex gap-2 comDiv align-items-start mb-2'
                                >
                                    <Avatar
                                        image={comment.creator?.profileImage?.image_url}
                                        label={comment.creator?.first_name?.[0]}
                                        shape="circle"
                                    />
                                    <div className="w-100 position-relative">
                                        <p className="mb-1">
                                            <strong>{comment.creator.first_name} {comment.creator.last_name}</strong>
                                        </p>
                                        <p className="mb-1">{comment.comment_text}</p>
                                        <small className="text-muted d-block mb-2">
                                            {new Date(comment.createdAt).toLocaleString('en-GB', {
                                                day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: true
                                            })}
                                        </small>

                                        <div className="d-flex justify-content-between">
                                            <Button
                                                title="Resolve"
                                                icon="pi pi-check-circle"
                                                severity="secondary"
                                                text
                                                className="p-0"
                                                onClick={() => handleResolveComment(comment.comment_id)}
                                                style={{
                                                    position: 'absolute',
                                                    background: 'transparent',
                                                    top: '-5px',
                                                    right: '-5px',
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>


                            ))}

                            {/* 👇 ADD THIS HERE 👇 */}
                            < div className="mt-3" >
                                <InputTextarea
                                    value={commentText}
                                    onChange={(e) => setCommentText(e.target.value)}
                                    className="px-2 py-1 w-100"
                                    placeholder="Add a comment..."
                                    rows={2}
                                />
                                <div className="text-end mt-1">
                                    <Button
                                        label="Send"
                                        severity="help+"
                                        className="py-1 border-0"
                                        onClick={() =>
                                            handleAddComment(
                                                section.images.find(img => img.image_id === showCommentId)
                                            )
                                        }
                                        disabled={!commentText.trim()}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <Dialog
                    header="Crop Image"
                    visible={showCrop}
                    onHide={() => setShowCrop(false)}
                    style={{ width: cropDialogSize.width }}
                    breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                >
                    {cropData && (
                        <>
                            <div style={{ width: "100%", height: cropDialogSize.height }}>
                                <ReactCrop
                                    crop={crop}
                                    onChange={newCrop => setCrop(newCrop)}
                                    onComplete={(c) => setCompletedCrop(c)}
                                    aspect={0} // freeform
                                >
                                    <img
                                        src={cropData.url}
                                        crossOrigin="anonymous"
                                        onLoad={e => setImageRef(e.currentTarget)}
                                        alt="Crop"
                                        style={{ maxHeight: cropDialogSize.height, maxWidth: '100%' }}
                                    />
                                </ReactCrop>
                            </div>

                            <div className="mt-3 text-end">
                                <Button
                                    label="Crop & Save"
                                    icon="pi pi-check"
                                    onClick={async () => {
                                        if (!completedCrop || !imageRef) return;

                                        const canvas = document.createElement('canvas');
                                        const scaleX = imageRef.naturalWidth / imageRef.width;
                                        const scaleY = imageRef.naturalHeight / imageRef.height;

                                        canvas.width = completedCrop.width;
                                        canvas.height = completedCrop.height;

                                        const ctx = canvas.getContext('2d');
                                        ctx.drawImage(
                                            imageRef,
                                            completedCrop.x * scaleX,
                                            completedCrop.y * scaleY,
                                            completedCrop.width * scaleX,
                                            completedCrop.height * scaleY,
                                            0,
                                            0,
                                            completedCrop.width,
                                            completedCrop.height
                                        );

                                        // Force output format
                                        const outputFormat = 'image/jpeg'; // change to 'image/png' if needed
                                        const fileExtension = outputFormat.split('/')[1];

                                        const base64Image = canvas.toDataURL(outputFormat);

                                        socket.emit("crop-card-image", {
                                            image_id: cropData.imageId,
                                            card_id: cardId,
                                            user_id: userId,
                                            croppedFile: {
                                                filename: `cropped_${cropData.imageId}.${fileExtension}`,
                                                file: base64Image.split(',')[1],
                                            }
                                        });

                                        setShowCrop(false);
                                    }}
                                />

                            </div>
                        </>
                    )}
                </Dialog>

                <Dialog
                    header="Edit Image"
                    visible={showEditDialog}
                    onHide={() => setShowEditDialog(false)}
                    style={{ width: '400px' }}
                >
                    <input type="file" accept="image/*" onChange={handleFileChange} />
                    <div className="mt-3 d-flex justify-content-end">
                        <Button label="Save" onClick={handleEditImage} disabled={!newFileData} />
                    </div>
                </Dialog>
                <Dialog
                    header="Confirm Delete"
                    visible={deleteDialogVisible}
                    onHide={() => setDeleteDialogVisible(false)}
                    footer={
                        <>
                            <Button
                                label="Cancel"
                                icon="pi pi-times"
                                className="p-button-text"
                                onClick={() => setDeleteDialogVisible(false)}
                            />
                            <Button
                                label="Delete"
                                icon="pi pi-trash"
                                className="p-button-danger"
                                onClick={() => {
                                    if (selectedImageToDelete) {
                                        socket.emit("delete-card-image", {
                                            image_id: selectedImageToDelete.image_id,
                                            card_id: cardId,
                                            user_id: userId
                                        });
                                    }
                                    setDeleteDialogVisible(false);
                                }}
                            />
                        </>
                    }
                >
                    <p>Are you sure you want to delete this image?</p>
                </Dialog>


            </Row >
        </>
    );
};

export default ImageSection;
